<template>
	<div class="select" tabindex="0" @blur="close" @keydown.esc="close">
		<div class="wrap">
			<div class="box">
				<div class="behind" @click="toggle">
					<div class="placeholder">Vælg</div>
					<div class="icon" v-html="require('@/assets/icons/minus-light.svg')" v-if="active"/>
					<div class="icon" v-html="require('@/assets/icons/plus-light.svg')" v-else/>
				</div>

				<div class="items">
					<div class="item" v-for="item in selectedItems" :key="item.id" @click="select(item)">
						{{item.label}}
						<span class="deselect" v-html="require('@/assets/icons/cross.svg')" />
					</div>
				</div>
			</div>

			<div class="dropdown" v-if="active">
				<item v-for="item in items" :key="item.id" v-bind="[item, {selectValue: value}]" @select="select" />
			</div>
		</div>
	</div>
</template>

<script>
import item from './item.vue';
import {xor} from "lodash";

export default {
	components: {item},
	props: {
		items: {type: Array, required: true}, // [{label, value}]
		value: {type: Array, required: true}, // [1,2]
		activeType: {type: String, required: true},
		name: {type: String, required: true}
	},
	computed: {
		selectedItems() {
			return this.items.filter(x => this.value.includes(x.value));
		},
		active() {
			return this.activeType === this.name;
		}
	},
	methods: {
		close() {
			this.$emit("activeType", "");
		},
		item(value) {
			return this.items.find(x => x.value === value);
		},
		toggle() {
			this.$emit("activeType", this.name);
		},
		select({value}) {
			this.$emit("input", xor(this.value, [value]));
		}
	}
};
</script>

<style lang="scss" scoped>
.select {
	user-select: none;
	outline: 0;

	.wrap {
		position: relative;

		.box {
			position: relative;
			background-color: $white1;
			border-radius: 2px;
			width: 100%;
			min-height: 38px;
			padding: 5px;

			.behind {
				position: absolute;
				left: 0;
				bottom: 0;
				right: 0;
				top: 0;
				display: flex;
				align-items: center;
				padding: 17px;
				.placeholder {
					color: #757575;
					font-size: 100%;
				}
				.icon {
					position: absolute;
					right: 10px;
					top: 10px;

					/deep/ svg {
						height: 18px;
						width: 18px;
						path {
							fill: black;
						}
					}
				}
			}

			.items {
				color: #000;
				font-size: 12px;
				padding-right: 25px;

				@include res(mobile) {
					font-size: 14px;
				}

				.item {
					display: none;
					padding: 4px;
					border-radius: 2px;
					background-color: #E1E0E4;
					border: 1px solid #22313A;
					margin: 3px;
					position: relative;
					z-index: 1;
					cursor: pointer;
					.deselect {
						/deep/ svg {
							vertical-align: middle;
							width: 9px;
							height: 9px;
							g {
								fill: black;
							}
						}
					}
				}
			}
		}

		.dropdown {
			z-index: 2;
			background-color: $white1;
			border-radius: 2px;
			position: absolute;
			top: calc(100% + 5px);
			left: 0;
			right: 0;
			max-height: 200px;
			overflow-y: auto;

			@include res(mobile) {
				border: 1px solid #E2E2E2;
			}
		}
	}
}
</style>
